module.exports = __webpack_public_path__ + "img/clean_energy.ccafde10.png";